import { ServiceRequestRepository } from './ServiceRequestInvoiceRepository'
import ServiceRequestModel from '../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'
import router from 'src/router'

export default class ServiceRequestInvoiceController {
  state = ServiceRequestModel.getInstance();
  order = { Overdue: 0, Negotiated: 1, Paid_Off: 2, Open: 3, Exempt: 4 }
  dadosFormSearch = {
    reference: { initial: null, final: null, inicial: null },
    dueDate: { initial: null, final: null, inicial: null }
  }

  formModalSearch = null
  initialFormModalSearch = null
  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestInvoiceController', new ServiceRequestInvoiceController())
  }

  async getInvoicesByUnid (id, client) {
    return await ServiceRequestRepository.invoicesByUnid(id, client)
  }

  async getSigreInvoicesByUnid (sigreCode) {
    const invoicesSigre = sigreCode ? await ServiceRequestRepository.sigreInvoicesByUnid(sigreCode) : []
    return invoicesSigre.sort((a, b) => (this.order[a.situacao] > this.order[b.situacao]) ? 1 : -1)
  }

  async sigreInvoicesByUnid () {
    const { protocol, consumerUnit } = router.app.$route.params
    const serviceRequest = this.state.serviceRequests[protocol].consumerUnits[consumerUnit]
    const { sigreCode, id } = serviceRequest
    const { client } = this.state.serviceRequests[protocol]

    const invoices = await this.getInvoicesByUnid(id, client)

    const invoicesSigre = await this.getSigreInvoicesByUnid(sigreCode)

    return [...invoices.reverse(), ...invoicesSigre]
  }

  async simpleAgreementsByUnid () {
    const { sigreCode } = this.state.serviceRequests[router.app.$route.params.protocol].consumerUnits[router.app.$route.params.consumerUnit]
    if (sigreCode) {
      const invoices = await ServiceRequestRepository.simpleAgreementsByUnid(sigreCode)
      return invoices.sort((a, b) => (this.order[a.situacao] > this.order[b.situacao]) ? 1 : -1)
    }
    return []
  }

  async formFilter () {
    if (!this.formModalSearch) {
      this.formModalSearch = await ServiceRequestRepository.formFilter()
      this.initialFormModalSearch = this.formModalSearch
    }

    return this.formModalSearch
  }

  resetFormFilter () {
    this.formModalSearch = { ...this.initialFormModalSearch }
  }

  async debitStatementFormByUnid () {
    const invoices = await ServiceRequestRepository.debitStatementFormByUnid(this.state.serviceRequests[router.app.$route.params.protocol].consumerUnits[router.app.$route.params.consumerUnit].sigreCode)
    return invoices
  }

  async valuesToCompensateFormByUnid () {
    const invoices = await ServiceRequestRepository.valuesToCompensateFormByUnid(this.state.serviceRequests[router.app.$route.params.protocol].consumerUnits[router.app.$route.params.consumerUnit].sigreCode)
    return invoices
  }

  async serviceRequestExemptionForm () {
    const form = await ServiceRequestRepository.serviceRequestExemptionForm()
    return form
  }

  async serviceRequestExemptionRecord (data) {
    await ServiceRequestRepository.serviceRequestExemptionRecord(data)
  }

  async createConsumerUnitFile (data) {
    await ServiceRequestRepository.createConsumerUnitFile(data)
  }
}
